import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgSortDesc = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 24,
	height: 24,
	fill: "none",
	viewBox: "0 0 24 24",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fill: "currentColor",
		d: "M12.157 16.94q.168.06.353.06.186 0 .349-.06a.85.85 0 0 0 .308-.202l3.592-3.552A.75.75 0 0 0 17 12.64q0-.31-.241-.55a.8.8 0 0 0-.556-.22q-.315 0-.525.213l-2.4 2.372V7.768q0-.327-.223-.547A.76.76 0 0 0 12.502 7a.76.76 0 0 0-.554.218.72.72 0 0 0-.223.54v6.696l-2.39-2.362a.73.73 0 0 0-.545-.23.82.82 0 0 0-.546.227.76.76 0 0 0-.244.542q-.003.3.228.53l3.618 3.577q.144.143.311.203"
	})
});
export default SvgSortDesc;
